// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Photo_wrap__dsMtl","grid":"Photo_grid__zYK2T","photo":"Photo_photo__MvQI8"};